import {IOwayoDataModel} from "./model";
import {EntwurfTransferStorage} from "./controller";
import {EventVerteiler} from "../global/eventVerteiler";
import {ColorUtils} from "./colorUtils";
import {OwayoLoader, ThreeDModelLoadedEventObject} from "./OwayoLoader";
import {PalettenLoader} from "./palettenLoader";
import {THREE} from "./resource/BVH.js";
import {createGUID} from "../global/globalUtils";
import {ENTWURF_EVENTNAMES, SELOBEVENTNAMES, SELOBTAB_EVENTNAMES} from "../global/GlobalEventnames";
import {Product} from "./product";
import {CONSTANTS} from "./meta_data";
import {
    ArtikelFarbVariante,
    ColorCodeFromDB,
    ColorCodeFromDBInfusedWithEntwurfColorData,
    EntwurfColorData, EntwurfFromDB
} from "./databaseInterfaceClasses";
import {PATTERN_EVENTNAMES} from "./pattern/patternFactory";
import {ResourceInvalidationTriggers} from "../global/resourcemanager/resourceManager";
import {OwayoKonfiPart} from "./owayoPartWithSelObs";
import globalsObject, {handleError, translate} from "./globalsObject";
import {Color} from "./colorObject";
import {arrayElementByKeyValue} from "../global/arrayHelper";
import {MotivLoader} from "./controllerModules/motivLoader";
import {PatternAnker} from "./pattern/partPatternContainer";
import {EntwuerfeVerwalter} from "./controllerModules/entwuerfeVerwaltung";


export class EntwurfInitialisator {
    private readonly model: IOwayoDataModel;
    private readonly isKundenKonfi: boolean;
    private readonly loadManager: THREE.LoadingManager;
    private readonly motiv: string | null;
    private readonly productColor: string | null;

    public constructor(model: IOwayoDataModel, isKundenKonfi: boolean, motiv = null, productColor = null) {
        this.motiv = motiv;
        this.productColor = productColor;
        this.loadManager = new THREE.LoadingManager();
        this.isKundenKonfi = isKundenKonfi;
        this.model = model;
    }

    public processInitNewEntwurf(productCategory: string, designName: string, model: string, entwurfTransferStorage: EntwurfTransferStorage, tryNumber = 0) {
        EventVerteiler.broadcast("initNewEntwurfEvent");
        let designInProduct = this.model.getCurrentOwayoProduct().getDesignObject(designName);

        if (this.isKundenKonfi && tryNumber === 0) {
            globalsObject.actionController.loadKundenKonfiVorbelegungsEntwurf(
                globalsObject.infoFromGetParameters.productInfo.design,
                {
                    productCategory: productCategory,
                    design: designName,
                    model: model
                }, tryNumber);
            return;
        }
        // wenn es das übergeben Design nicht in den Possible Designs gibt, dann laden wir das basisdesign der Designliste
        if (designInProduct === null || designInProduct === undefined) {
            designInProduct = this.model.getCurrentOwayoProduct().getBaseDesign();
        }

        // und wenn es das Basisdesign auch nicht gibt, nehmen wir einfach das erste
        if (designInProduct === null || designInProduct === undefined) {
            designInProduct = this.model.getCurrentOwayoProduct().possibleDesigns[0];
        }

        this.model.entwurf.setEntwurfData({
            id: (this.model.entwurf.getID() !== "") ? this.model.entwurf.getID() : createGUID(),
            productCategory: productCategory,
            design: designInProduct.Design,
            model: model,
            startDirty:(this.model.entwurf.getID() !== "")
        });
        // EventVerteiler.broadcast("newEntwurfsObjectCreated", this.model.entwurf);

        this.model.entwurf.setLoadStatusToTrue("EXEMPLARLISTE");
        if (!this.isKundenKonfi && !this.motiv) {
            this.model.entwurf.setLoadStatusToTrue("TEXT");
            this.model.entwurf.setLoadStatusToTrue("LOGO");
        } else {
            if (this.motiv) {
                globalsObject.resourceManager.createTask("loadMotiv")
                    .discardAfterExecution()
                    .when("entwurfcolorsLoaded", "done")
                    .thenDo(() => MotivLoader.loadMotiv(this.model, this.motiv, this.productColor));
            } else {
                EventVerteiler.broadcast(SELOBEVENTNAMES.LOAD_KK_VORBELEGUNGSSELOBS);
            }

        }

        this.activateProductOrArticleView();

        EventVerteiler.broadcast("initEntwurfColorCodesEvent", {
                colorCodes: this.model.getCurrentOwayoProduct().colorCodes,
                ColorCodeFarbVorbelegungen: this.model.getCurrentOwayoProduct().ColorCodeFarbVorbelegungen,
                ColorCodeAbhaengigkeiten: designInProduct.ColorCodeAbhaengigkeiten,
                entwurfTransferStorage: entwurfTransferStorage,
                quickFixDontCareAboutColorValuesIsSetWhenLoadingSavedEntwurf: false
            }
        );
        this.initViewComponents();

        if (this.model.getCurrentOwayoProduct().VorgegebenerArtikel !== "") {
            const farbvariante = this.model.getCurrentOwayoProduct().Farbvarianten[Object.keys(this.model.getCurrentOwayoProduct().Farbvarianten)[0]];
            const paletten = PalettenLoader.getPalettenToLoad(farbvariante);
            paletten.forEach(p => PalettenLoader.loadSinglePalette(p));
            //this.setColorsFarbvariante(farbvariante);
            this.model.entwurf.setFarbvariante(Object.keys(this.model.getCurrentOwayoProduct().Farbvarianten)[0]);
        }

        if(this.model.getCurrentOwayoProduct().ordertype === entwurfTransferStorage.ordertype){
            this.model.entwurf.setRdyDesignID(entwurfTransferStorage.rdyDesignID);
        }

        EventVerteiler.broadcast('DreiDPartsnachBedarfEinUndAusblendenEvent', {features: this.model.getCurrentOwayoProduct().selectedFeatures});
        globalsObject.resourceManager.registerLoadedResourceWithoutData("entwurfInitialized", "productChange");
    }

    public initNewEntwurf(productCategory: string, designName: string, model: string, entwurfTransferStorage: EntwurfTransferStorage, tryNumber = 0) {
        const $this = this;
        EventVerteiler.resourceManager.createTask("initNewEntwurf").when("produkt.php", "loaded")
            .thenDo(() => $this.processInitNewEntwurf(productCategory, designName, model, entwurfTransferStorage, tryNumber));
    }

    private activateProductOrArticleView() {
        const isArticle = this.model.getCurrentOwayoProduct().VorgegebenerArtikel !== "";
        if (isArticle) {
            EventVerteiler.broadcast(SELOBTAB_EVENTNAMES.ACTIVATE_ARTIKEL_VIEW);
        } else {
            EventVerteiler.broadcast(SELOBTAB_EVENTNAMES.ACTIVATE_PRODUCT_VIEW);
        }
    }

    private initViewComponents() {
        this.load3dModel();
        EventVerteiler.broadcast("initColorsEvent", {colorCodes: this.model.entwurf.getColorObjects()});
    }


    private load3dModel() {
        EventVerteiler.broadcast("modelAboutToBeLoadedEvent");
        const loader = new OwayoLoader(this.loadManager),
            $this = this;

        loader.loadZipped(this.getMirlURL(this.model.getCurrentOwayoProduct()))
            .then(function (data: ThreeDModelLoadedEventObject) {
                data.model = $this.model.getCurrentOwayoProduct().model;
                data.cut = $this.model.getCurrentOwayoProduct().cut;
                data.features = $this.model.getCurrentOwayoProduct().selectedFeatures;
                EventVerteiler.broadcast("threeDModelLoadedEvent", data);
            }).catch(function () {
            handleError("fatal", "load3dModel", translate("konf_errorLoadModell", "Das 3D Modell konnte nicht geladwen werden"));
        });
    }

    private getMirlURL = (currentOwayoProduct: Product) => CONSTANTS.MODEL_PATH + [currentOwayoProduct.cut, currentOwayoProduct.model, currentOwayoProduct.model].join("/") + '.mirl';

    private static infuseColorCodesWithColorValues(designColorCodes: ColorCodeFromDB[], colors: EntwurfColorData[]): ColorCodeFromDBInfusedWithEntwurfColorData[] {
        return designColorCodes.map((c) => {
            const enturfColorData = arrayElementByKeyValue(colors, "bezeichnung", c.colorCode) as EntwurfColorData;
            const out = new ColorCodeFromDBInfusedWithEntwurfColorData(c);
            if (enturfColorData === null) {
                return out;
            }
            out.hatPattern = enturfColorData.hatPattern;
            out.palette = enturfColorData.palette;
            out.farbname = enturfColorData.nameImWeb;
            out.colorRGB = enturfColorData.colorRGB;
            return out;
        });
    }

    private loadTextObjects(textobjects) {
        this.model.entwurf.loadTextObjects(textobjects);
        EventVerteiler.broadcast("textObjectsLoaded", {texts: this.model.entwurf.getTextObjects()});
    }

    private loadLogoObjects(logos) {
        this.model.entwurf.loadLogoObjects(logos);
        EventVerteiler.broadcast("logoObjectsLoaded", {logos: this.model.entwurf.getLogoObjects()});
    }

    private static loadPatterns(patterns) {
        globalsObject.resourceManager.createTask("insertPatternsAfterLoad").discardAfterExecution()
            .when("stocklogos", "loaded").andWhen("owayoJSViewerWithSelObs_parts.json_Loaded", "loaded")
            .thenDo(() => {
                EventVerteiler.broadcast(PATTERN_EVENTNAMES.LOADED, {patterns: patterns})
            });
    }

    public static initReadyDesignPatterns(patterns) {
        EntwurfInitialisator.loadPatterns(patterns);
    }

    public initLoadedEntwurf(data: EntwurfFromDB, saveId: string, entwurfTransferStorage: EntwurfTransferStorage) {
        const designInProduct = arrayElementByKeyValue(this.model.getCurrentOwayoProduct().possibleDesigns, "Design", data.design);
        const ColorCodeAbhaengigkeiten = designInProduct !== null ? designInProduct.ColorCodeAbhaengigkeiten : [];

        this.model.entwurf.setEntwurfData({
            id: saveId,
            productCategory: data.derived_designliste,
            design: data.design,
            model: data.model,
            uploadedByOwayo: data.uploadedByOwayo,
            basedOnDeprecatedProduct: data.basedOnDeprecatedProduct,
            ersetztDurch: data.internationalizedProduktErsetztDurch,
            ersetztDurchAuwiProdukt: data.produktErsetztDurchAuwiProdukt,
            name: data.name,
            wasOrdered: data.wasOrdered,
            isInWarenkorb:data.isInWarenkorb,
            startDirty:false
        });
        this.model.entwurf.setRdyDesignID(data.rdyDesignID);
        this.model.entwurf.setHerstellerlogosDeleted(data.herstellerlogosEntfernt);
        if(this.model.getWebsportFuerProduktAuswahlNormalized() !== data.derived_sport) {
            EventVerteiler.broadcast("ReloadproduktauswahlEvent", data.derived_sport);
            globalsObject.resourceManager.executeInvalidation(ResourceInvalidationTriggers.SPORT_CHANGED);
        }
        this.model.setWebsportFuerProduktAuswahlNormalized(data.derived_sport);
        this.model.setWebsportFuerProduktAuswahlInt(data.derived_sportInt);
        // this.model.sportUnterDemDasProduktGefuehrtWird = data.realsport;
        EventVerteiler.broadcast("realsportChanged");
        const infused = EntwurfInitialisator.infuseColorCodesWithColorValues(this.model.getCurrentOwayoProduct().colorCodes, data.colors);
        EventVerteiler.broadcast(
            "initEntwurfColorCodesEvent",
            {
                colorCodes: infused,
                ColorCodeFarbVorbelegungen: this.model.getCurrentOwayoProduct().ColorCodeFarbVorbelegungen,
                ColorCodeAbhaengigkeiten,
                entwurfTransferStorage: entwurfTransferStorage,
                quickFixDontCareAboutColorValuesIsSetWhenLoadingSavedEntwurf: true
            }
        );
        EventVerteiler.broadcast(SELOBTAB_EVENTNAMES.DISPLAYFALLBACK);
        EventVerteiler.broadcast("entwurfLoadingEvent", saveId);
        //die folgenden beiden Funktionen bauen auch die zOdertable auf!
        this.loadTextObjects(data.textobjects);
        this.loadLogoObjects(data.logos);
        // EntwurfInitialisator.setpatternAnkerFromDB(data.patternAnker);
        EventVerteiler.broadcast(SELOBEVENTNAMES.CHECK_Z_ORDERTABLE);
        EntwurfInitialisator.loadPatternAnker(data.patternAnker);
        EntwurfInitialisator.loadPatterns(data.patterns);

        this.model.entwurf.loadEinzelexemplare(data.einzelexemplare);
        this.model.entwurf.loadColorValues(data.colors);
        this.initViewComponents();
        if (data.basedOnDeprecatedProduct === true) {
            EventVerteiler.broadcast("entwurfBasedOnDeprecatedProductEvent", {
                newProduct: data.internationalizedProduktErsetztDurch,
                newAuwiProdukt: data.produktErsetztDurchAuwiProdukt
            });
        }
        globalsObject.resourceManager.registerResource({
            resourceName: "loadedEntwurfInitialized",
            invalidatedWhen: ResourceInvalidationTriggers.PRODUCTCHANGE,
            startingStati: ["done"]
        });

        if (this.model.getCurrentOwayoProduct().VorgegebenerArtikel !== "") {
            this.model.entwurf.setFarbvariante(data.farbvariante);
            if (this.model.entwurf.getFarbvariante() === null || this.model.entwurf.getFarbvariante() === "") {
                EventVerteiler.broadcast("setSelectedFarbvarianteEvent", this.getFarbvariantenNameFromColors());
            } else {
                EventVerteiler.broadcast("setSelectedFarbvarianteEvent", this.model.entwurf.getFarbvariante());
            }
        }
        globalsObject.resourceManager.registerLoadedResourceWithoutData("entwurfInitialized", "productChange");
        EventVerteiler.broadcast(ENTWURF_EVENTNAMES.LOADEDENTWURF_INITIALIZED);

        if (globalsObject.infoFromGetParameters.takePreviews === true) {
            globalsObject.infoFromGetParameters.takePreviews = false;
            EntwuerfeVerwalter.entwurfIsMissingPreviewPic();
        }
    }

    private getFarbvariantenNameFromColors() {
        for (const farbvariantenname in this.model.getCurrentOwayoProduct().Farbvarianten) {
            if (this.StimmtFarbvarianteMitEntwurfUeberein(this.model.getCurrentOwayoProduct().Farbvarianten[farbvariantenname])) {
                return farbvariantenname;
            }
        }
    }

    private StimmtFarbvarianteMitEntwurfUeberein(farbvariante: ArtikelFarbVariante[]) {
        for (let t = 0; t < farbvariante.length; t++) {
            if ((this.model.entwurf.getColorObjectByColorCode(farbvariante[t].colorcode) as Color).colorValue !==
                ColorUtils.hexToDec(farbvariante[t].RGBHex)) {
                return false;
            }
        }
        return true;
    }

    private static loadPatternAnker(patternAnker: PatternAnker[]) {
        globalsObject.resourceManager.createTask("insertSavedAnker").when("owayoJSViewerWithSelObs_parts.json_Loaded", "loaded").thenDo(() => {
            globalsObject.owayoJSViewer.getDroppableParts().forEach(function (p: OwayoKonfiPart) {
                const anker = patternAnker.find(pa => pa.partname === p.name);
                if (typeof (anker) !== "undefined") {
                    p.patternAnker = anker.anker;
                }
            })
        });
    }
}
